(function () {
  function applyJudgeMeSettingsOverrides() {
    if (!window.jdgmSettings) {
      return;
    }

    window.jdgmSettings.widget_first_sub_tab = "shop-reviews";
  }

  applyJudgeMeSettingsOverrides();

  const locale = (document.documentElement.lang || "en").toLowerCase();
  const language = locale.split("-")[0];

  const strings = {
    en: {
      reviewTitle: "Customer Reviews",
      productReviews: "Product reviews",
      storeReviews: "Store reviews",
      mostRecent: "Most recent",
      filter: "Filters",
      readMore: "Read more",
      close: "Close",
      translate: "Translate",
      translating: "Translating...",
      translatedLabel: "Translation",
      showOriginal: "Original",
      showTranslation: "Translate",
      failed: "Translation unavailable. Try again later.",
    },
    nl: {
      reviewTitle: "Klantreviews",
      productReviews: "Productreviews",
      storeReviews: "Winkelreviews",
      mostRecent: "Meest recent",
      filter: "Filters",
      readMore: "Lees meer",
      close: "Sluiten",
      translate: "Vertaal",
      translating: "Vertalen...",
      translatedLabel: "Vertaling",
      showOriginal: "Origineel",
      showTranslation: "Vertaal",
      failed: "Vertaling niet beschikbaar. Probeer het later opnieuw.",
    },
    de: {
      reviewTitle: "Kundenbewertungen",
      productReviews: "Produktbewertungen",
      storeReviews: "Shop-Bewertungen",
      mostRecent: "Neueste",
      filter: "Filter",
      readMore: "Mehr lesen",
      close: "Schliessen",
      translate: "Ubersetzen",
      translating: "Wird ubersetzt...",
      translatedLabel: "Ubersetzung",
      showOriginal: "Original anzeigen",
      showTranslation: "Ubersetzen",
      failed: "Ubersetzung derzeit nicht verfugbar.",
    },
    fr: {
      reviewTitle: "Avis clients",
      productReviews: "Avis produit",
      storeReviews: "Avis boutique",
      mostRecent: "Plus recents",
      filter: "Filtres",
      readMore: "Lire plus",
      close: "Fermer",
      translate: "Traduire",
      translating: "Traduction...",
      translatedLabel: "Traduction",
      showOriginal: "Original",
      showTranslation: "Traduire",
      failed: "Traduction indisponible pour le moment.",
    },
    tr: {
      reviewTitle: "Musteri yorumlari",
      productReviews: "Urun yorumlari",
      storeReviews: "Magaza yorumlari",
      mostRecent: "En yeni",
      filter: "Filtreler",
      readMore: "Devamini oku",
      close: "Kapat",
      translate: "Cevir",
      translating: "Cevriliyor...",
      translatedLabel: "Ceviri",
      showOriginal: "Orijinali goster",
      showTranslation: "Cevir",
      failed: "Ceviri su anda kullanilamiyor.",
    },
    ar: {
      reviewTitle: "آراء العملاء",
      productReviews: "آراء المنتجات",
      storeReviews: "آراء المتجر",
      mostRecent: "الأحدث",
      filter: "فلاتر",
      readMore: "اقرأ المزيد",
      close: "إغلاق",
      translate: "ترجمة",
      translating: "جار الترجمة...",
      translatedLabel: "الترجمة",
      showOriginal: "الأصل",
      showTranslation: "ترجمة",
      failed: "الترجمة غير متاحة حاليا.",
    },
  };

  const labels = strings[language] || strings.en;
  let enhanceScheduled = false;
  let pendingEnhanceTimeout = null;
  const supplementalReviewCache = new Map();
  const translationCache = new Map();
  const supplementalReviewCacheKeyPrefix = "amumin-review-supplemental-v1:";
  const translationCacheKeyPrefix = `amumin-review-translation-v1:${language}:`;
  const supplementalReviewCacheTtl = 10 * 60 * 1000;
  const translationCacheTtl = 30 * 24 * 60 * 60 * 1000;

  function getReviewItems(root) {
    return root.querySelectorAll(".jm-review-item, .jdgm-rev");
  }

  function getReviewBodyElement(review) {
    return (
      review.querySelector(".jm-review-content__body") ||
      review.querySelector(".jdgm-review-content__body-content") ||
      review.querySelector(".jm-review-body-wrapper") ||
      review.querySelector(".jdgm-rev__body") ||
      review.querySelector(".jdgm-rev__body-content") ||
      review.querySelector(".jdgm-rev__content")
    );
  }

  function getReviewTitleElement(review) {
    return review.querySelector(".jm-review-content__title, .jdgm-rev__title");
  }

  function getAuthorElement(review) {
    return review.querySelector(".amumin-review-author, .jm-reviewer-info__name, .jdgm-rev__author");
  }

  function getTimestampElement(review) {
    const custom = review.querySelector(".amumin-review-date");
    if (custom) {
      return custom;
    }

    const legacy = review.querySelector(".jdgm-rev__timestamp");
    if (legacy) {
      return legacy;
    }

    const candidates = Array.from(review.querySelectorAll(".jm-reviewer-info__details .jm-cluster, .jm-reviewer-info__details .jm-text"));
    return (
      candidates.find((element) => /^\d{2}[/-]\d{2}[/-]\d{4}$/.test((element.textContent || "").trim())) ||
      null
    );
  }

  function getStarsElement(review) {
    const revampStars = review.querySelector(".jm-star-rating");
    if (revampStars) {
      const wrapper = revampStars.closest(".jm-cluster");
      if (wrapper && wrapper.children.length === 1) {
        return wrapper;
      }
      return revampStars;
    }

    return review.querySelector(".jdgm-row-stars");
  }

  function getTextContent(element) {
    return element ? element.innerText.trim() : "";
  }

  function escapeHtml(text) {
    return text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function setTextIfChanged(element, nextText) {
    if (element && element.textContent !== nextText) {
      element.textContent = nextText;
    }
  }

  function hasOverflow(element) {
    if (!element) {
      return false;
    }

    return element.scrollHeight > element.clientHeight + 2 || element.scrollWidth > element.clientWidth + 2;
  }

  function hashString(value) {
    let hash = 2166136261;

    for (let index = 0; index < value.length; index += 1) {
      hash ^= value.charCodeAt(index);
      hash = Math.imul(hash, 16777619);
    }

    return (hash >>> 0).toString(36);
  }

  function readCachedValue(storage, key) {
    try {
      const rawValue = storage.getItem(key);

      if (!rawValue) {
        return null;
      }

      const parsed = JSON.parse(rawValue);

      if (!parsed || typeof parsed !== "object" || parsed.expiresAt < Date.now()) {
        storage.removeItem(key);
        return null;
      }

      return parsed.value ?? null;
    } catch (error) {
      return null;
    }
  }

  function writeCachedValue(storage, key, value, ttl) {
    try {
      storage.setItem(
        key,
        JSON.stringify({
          expiresAt: Date.now() + ttl,
          value,
        })
      );
    } catch (error) {
      // Ignore storage quota and privacy-mode failures.
    }
  }

  function buildParagraphMarkup(text) {
    const paragraphs = String(text || "")
      .split(/\n+/)
      .map((line) => line.trim())
      .filter(Boolean)
      .map((line) => `<p>${escapeHtml(line)}</p>`);

    return paragraphs.join("") || "<p></p>";
  }

  function getReviewState(review) {
    if (review.__amuminReviewState) {
      return review.__amuminReviewState;
    }

    const titleElement = getReviewTitleElement(review);
    const bodyElement = getReviewBodyElement(review);
    const state = {
      originalTitleText: getTextContent(titleElement),
      originalBodyText: getTextContent(bodyElement),
      originalBodyHtml: bodyElement?.innerHTML || "<p></p>",
      translated: null,
      isTranslated: false,
    };

    review.__amuminReviewState = state;
    return state;
  }

  function getReviewTranslationCacheKey(review) {
    const state = getReviewState(review);
    const author = getTextContent(getAuthorElement(review));
    const date = getTextContent(getTimestampElement(review));
    const signature = [author, date, state.originalTitleText, state.originalBodyText].join("|");
    return `${translationCacheKeyPrefix}${hashString(signature)}`;
  }

  function getCachedTranslation(review) {
    const cacheKey = getReviewTranslationCacheKey(review);

    if (translationCache.has(cacheKey)) {
      return translationCache.get(cacheKey);
    }

    const persisted = readCachedValue(window.localStorage, cacheKey);

    if (!persisted) {
      return null;
    }

    translationCache.set(cacheKey, persisted);
    return persisted;
  }

  function setCachedTranslation(review, translated) {
    const cacheKey = getReviewTranslationCacheKey(review);
    translationCache.set(cacheKey, translated);
    writeCachedValue(window.localStorage, cacheKey, translated, translationCacheTtl);
  }

  function applyReviewState(review, useTranslated) {
    const state = getReviewState(review);
    const titleElement = getReviewTitleElement(review);
    const bodyElement = getReviewBodyElement(review);

    if (!bodyElement) {
      return;
    }

    if (useTranslated && state.translated) {
      if (titleElement) {
        titleElement.textContent = state.translated.title || "";
        titleElement.hidden = !state.translated.title;
      }

      bodyElement.innerHTML = buildParagraphMarkup(state.translated.body);
      state.isTranslated = true;
      return;
    }

    if (titleElement) {
      titleElement.textContent = state.originalTitleText || "";
      titleElement.hidden = !state.originalTitleText;
    }

    bodyElement.innerHTML = state.originalBodyHtml;
    state.isTranslated = false;
  }

  function updateTranslateButtons(review) {
    const state = getReviewState(review);
    const nextLabel = state.isTranslated ? labels.showOriginal : labels.showTranslation;
    const reviewButton = review.querySelector(".amumin-review-translate");

    if (reviewButton) {
      reviewButton.textContent = nextLabel;
    }

    const modal = document.querySelector(".amumin-review-modal");

    if (modal && modal.__amuminCurrentReview === review) {
      const modalButton = modal.querySelector(".amumin-review-modal__translate");

      if (modalButton) {
        modalButton.textContent = nextLabel;
      }
    }
  }

  function ensureReviewModal() {
    let modal = document.querySelector(".amumin-review-modal");

    if (modal) {
      return modal;
    }

    modal = document.createElement("div");
    modal.className = "amumin-review-modal";
    modal.hidden = true;
    modal.innerHTML = `
      <div class="amumin-review-modal__backdrop" data-amumin-modal-close="true"></div>
      <div class="amumin-review-modal__dialog" role="dialog" aria-modal="true" aria-label="${escapeHtml(labels.reviewTitle)}">
        <div class="amumin-review-modal__header-actions">
          <button type="button" class="amumin-review-modal__translate">${escapeHtml(labels.translate)}</button>
          <button type="button" class="amumin-review-modal__close">${escapeHtml(labels.close)}</button>
        </div>
        <div class="amumin-review-modal__author"></div>
        <div class="amumin-review-modal__meta"></div>
        <h3 class="amumin-review-modal__title"></h3>
        <div class="amumin-review-modal__body"></div>
      </div>
    `;

    const closeModal = () => {
      modal.classList.remove("is-visible");
      window.setTimeout(() => {
        modal.hidden = true;
      }, 160);
    };

    modal.querySelector("[data-amumin-modal-close='true']").addEventListener("click", closeModal);
    modal.querySelector(".amumin-review-modal__close").addEventListener("click", closeModal);
    modal.querySelector(".amumin-review-modal__translate").addEventListener("click", async () => {
      const review = modal.__amuminCurrentReview;

      if (!review) {
        return;
      }

      const button = modal.querySelector(".amumin-review-modal__translate");
      await toggleReviewTranslation(review, button);
      populateReviewModal(modal, review);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !modal.hidden) {
        closeModal();
      }
    });

    document.body.appendChild(modal);
    modal.closeAmuminReviewModal = closeModal;
    return modal;
  }

  function populateReviewModal(modal, review) {
    const author = getAuthorElement(review)?.textContent.trim() || "";
    const date = getTimestampElement(review)?.textContent.trim() || "";
    const title = getReviewTitleElement(review)?.textContent.trim() || "";
    const bodyHtml = getReviewBodyElement(review)?.innerHTML || "";
    const stars = getStarsElement(review)?.cloneNode(true);

    modal.querySelector(".amumin-review-modal__author").textContent = author;
    modal.querySelector(".amumin-review-modal__title").textContent = title;
    modal.querySelector(".amumin-review-modal__body").innerHTML = bodyHtml;

    const meta = modal.querySelector(".amumin-review-modal__meta");
    meta.innerHTML = "";

    if (date) {
      const dateElement = document.createElement("div");
      dateElement.className = "amumin-review-date";
      dateElement.textContent = date;
      meta.appendChild(dateElement);
    }

    if (stars) {
      meta.appendChild(stars);
    }
  }

  function openReviewModal(review) {
    const modal = ensureReviewModal();
    modal.__amuminCurrentReview = review;
    populateReviewModal(modal, review);
    updateTranslateButtons(review);

    modal.hidden = false;
    window.requestAnimationFrame(() => {
      modal.classList.add("is-visible");
    });
  }

  function getActivePage(root) {
    const activeButton = root.querySelector(
      ".jm-pagination-controls__button--active, .jdgm-paginate__page.jdgm-curt, .jdgm-paginate .current"
    );
    const pageNumber = Number.parseInt((activeButton?.textContent || "1").trim(), 10);
    return Number.isFinite(pageNumber) && pageNumber > 0 ? pageNumber : 1;
  }

  function getCurrentSortValue(root) {
    const sortSelect = root.querySelector(".jm-sort-filter__select, .jdgm-sort-dropdown");
    const rawValue = (sortSelect?.value || "").trim();

    if (!rawValue || rawValue === "most_recent" || rawValue === "most-recent") {
      return { sort_by: "created_at", sort_dir: "desc" };
    }

    if (rawValue === "created_at") {
      return { sort_by: "created_at", sort_dir: "desc" };
    }

    if (rawValue === "highest_rating") {
      return { sort_by: "rating", sort_dir: "desc" };
    }

    if (rawValue === "lowest_rating") {
      return { sort_by: "rating", sort_dir: "asc" };
    }

    if (rawValue === "most_helpful") {
      return { sort_by: "thumbs_up_count", sort_dir: "desc" };
    }

    return { sort_by: rawValue };
  }

  function formatReviewDate(rawDate) {
    const date = new Date(rawDate);

    if (Number.isNaN(date.getTime())) {
      return "";
    }

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  function buildStarsMarkup(rating) {
    const stars = [];

    for (let index = 1; index <= 5; index += 1) {
      const state = index <= rating ? "jdgm--on" : "jdgm--off";
      stars.push(`<span class="jdgm-star ${state}"></span>`);
    }

    return `<div class="jdgm-row-stars">${stars.join("")}</div>`;
  }

  function buildSupplementalReview(review) {
    const wrapper = document.createElement("article");
    wrapper.className = "jm-review-item amumin-review-supplemental";
    wrapper.dataset.amuminMetaReady = "true";

    const titleHtml = review.title
      ? `<h3 class="jm-review-content__title">${escapeHtml(review.title)}</h3>`
      : "";

    const bodyParagraphs = (review.body || "")
      .split(/\n+/)
      .filter(Boolean)
      .map((line) => `<p>${escapeHtml(line)}</p>`)
      .join("");

    wrapper.innerHTML = `
      <div class="jm-review-item__content">
        <div class="amumin-review-meta">
          <div class="amumin-review-author">${escapeHtml(review.reviewer_name || labels.showOriginal)}</div>
          <div class="amumin-review-date">${formatReviewDate(review.created_at)}</div>
          ${buildStarsMarkup(review.rating || 0)}
        </div>
        <div class="jm-review-content">
          ${titleHtml}
          <div class="jm-review-content__body">${bodyParagraphs || "<p></p>"}</div>
        </div>
      </div>
    `;

    return wrapper;
  }

  async function fetchSupplementalReview(root) {
    const currentPage = getActivePage(root);
    const nextPage = currentPage + 1;
    const shopDomain = window.Shopify?.shop;

    if (!shopDomain) {
      return null;
    }

    const sort = getCurrentSortValue(root);
    const cacheKey = JSON.stringify({ page: nextPage, sort });
    const persistedCacheKey = `${supplementalReviewCacheKeyPrefix}${hashString(cacheKey)}`;

    if (supplementalReviewCache.has(cacheKey)) {
      return supplementalReviewCache.get(cacheKey);
    }

    const persistedReview = readCachedValue(window.sessionStorage, persistedCacheKey);
    if (persistedReview) {
      const cachedPromise = Promise.resolve(persistedReview);
      supplementalReviewCache.set(cacheKey, cachedPromise);
      return cachedPromise;
    }

    const url = new URL("https://cdn.judge.me/reviews/all_reviews_js_based");
    url.searchParams.set("widget_type", "review-widget");
    url.searchParams.set("review_type", "shop-reviews");
    url.searchParams.set("page", String(nextPage));
    url.searchParams.set("platform", "shopify");
    url.searchParams.set("shop_domain", shopDomain);

    Object.entries(sort).forEach(([key, value]) => {
      if (value) {
        url.searchParams.set(key, value);
      }
    });

    const promise = fetch(url.toString())
      .then((response) => {
        if (!response.ok) {
          throw new Error("supplemental review request failed");
        }

        return response.json();
      })
      .then((payload) => payload.reviews?.[0] || null)
      .then((review) => {
        if (review) {
          writeCachedValue(window.sessionStorage, persistedCacheKey, review, supplementalReviewCacheTtl);
        }

        return review;
      })
      .catch(() => null);

    supplementalReviewCache.set(cacheKey, promise);
    return promise;
  }

  async function ensureSixthDesktopReview(root) {
    if (!window.matchMedia("(min-width: 990px)").matches) {
      return;
    }

    const reviewList = root.querySelector(".jdgm-review-list");

    if (!reviewList) {
      return;
    }

    const storeTab = root.querySelector("#jdgm-tab_shop_reviews");
    if (storeTab && storeTab.getAttribute("aria-selected") !== "true") {
      reviewList.querySelectorAll(".amumin-review-supplemental").forEach((element) => element.remove());
      delete reviewList.dataset.amuminSupplementalKey;
      return;
    }

    const reviews = Array.from(reviewList.querySelectorAll(".jm-review-item, .jdgm-rev"));
    const baseReviews = reviews.filter((review) => !review.classList.contains("amumin-review-supplemental"));
    const activePage = getActivePage(root);
    const sort = getCurrentSortValue(root);
    const supplementalKey = JSON.stringify({ page: activePage, sort });

    if (baseReviews.length !== 5) {
      reviewList.querySelectorAll(".amumin-review-supplemental").forEach((element) => element.remove());
      delete reviewList.dataset.amuminSupplementalKey;
      return;
    }

    if (
      reviewList.dataset.amuminSupplementalKey === supplementalKey &&
      reviewList.querySelector(".amumin-review-supplemental")
    ) {
      return;
    }

    reviewList.querySelectorAll(".amumin-review-supplemental").forEach((element) => element.remove());

    const supplementalReview = await fetchSupplementalReview(root);
    if (!supplementalReview) {
      delete reviewList.dataset.amuminSupplementalKey;
      return;
    }

    const supplementalElement = buildSupplementalReview(supplementalReview);
    reviewList.appendChild(supplementalElement);
    createTranslationUI(supplementalElement);
    createReadMoreUI(supplementalElement);
    reviewList.dataset.amuminSupplementalKey = supplementalKey;
  }

  async function translateText(text) {
    const url =
      "https://translate.googleapis.com/translate_a/single?client=gtx&sl=auto&dt=t&tl=" +
      encodeURIComponent(language) +
      "&q=" +
      encodeURIComponent(text);
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error("translate failed");
    }

    const payload = await response.json();
    const translated = Array.isArray(payload?.[0])
      ? payload[0].map((entry) => entry[0]).join("")
      : "";

    return translated.trim() || text;
  }

  async function translateReview(review) {
    const state = getReviewState(review);
    const title = state.originalTitleText;
    const body = state.originalBodyText;
    const pieces = [];

    if (title) {
      pieces.push({ key: "title", value: title });
    }
    if (body) {
      pieces.push({ key: "body", value: body });
    }

    const result = {};
    for (const piece of pieces) {
      result[piece.key] = await translateText(piece.value);
    }

    return result;
  }

  async function toggleReviewTranslation(review, triggerButton) {
    const state = getReviewState(review);
    const relatedButtons = [
      review.querySelector(".amumin-review-translate"),
      document.querySelector(".amumin-review-modal")?.__amuminCurrentReview === review
        ? document.querySelector(".amumin-review-modal__translate")
        : null,
      triggerButton,
    ].filter(Boolean);

    if (state.isTranslated) {
      applyReviewState(review, false);
      createReadMoreUI(review);
      updateTranslateButtons(review);
      return;
    }

    if (!state.translated) {
      const cachedTranslation = getCachedTranslation(review);

      if (cachedTranslation) {
        state.translated = cachedTranslation;
      } else {
        relatedButtons.forEach((button) => {
          button.disabled = true;
          button.textContent = labels.translating;
        });

        try {
          state.translated = await translateReview(review);
          setCachedTranslation(review, state.translated);
        } catch (error) {
          const button = review.querySelector(".amumin-review-translate");
          if (button) {
            button.textContent = labels.failed;
            window.setTimeout(() => {
              updateTranslateButtons(review);
            }, 1800);
          }

          const modal = document.querySelector(".amumin-review-modal");
          if (modal && modal.__amuminCurrentReview === review) {
            const modalButton = modal.querySelector(".amumin-review-modal__translate");
            if (modalButton) {
              modalButton.textContent = labels.failed;
              window.setTimeout(() => {
                updateTranslateButtons(review);
              }, 1800);
            }
          }

          relatedButtons.forEach((buttonNode) => {
            buttonNode.disabled = false;
          });

          return;
        }
      }
    }

    relatedButtons.forEach((button) => {
      button.disabled = false;
    });

    applyReviewState(review, true);
    createReadMoreUI(review);
    updateTranslateButtons(review);
  }

  function localizeWidgetCopy(root) {
    root
      .querySelectorAll(
        ".jm-review-widget-minimal-header__title, .jdgm-rev-widg__title, .jdgm-all-reviews-widget__title, .jdgm-all-reviews-page__title"
      )
      .forEach((element) => {
        setTextIfChanged(element, labels.reviewTitle);
        element.dataset.amuminLocalized = "true";
      });

    root.querySelectorAll(".jdgm-tab, .jdgm-subtab__name").forEach((element) => {
      const text = element.textContent.trim().toLowerCase();
      const count = element.textContent.match(/\(\d+\)/);
      let nextText = null;

      if (text.includes("product")) {
        nextText = count ? `${labels.productReviews} ${count[0]}` : labels.productReviews;
      } else if (text.includes("store") || text.includes("shop")) {
        nextText = count ? `${labels.storeReviews} ${count[0]}` : labels.storeReviews;
      }

      if (nextText) {
        setTextIfChanged(element, nextText);
      }
    });

    root.querySelectorAll(".jm-custom-answer-filter__text").forEach((element) => {
      setTextIfChanged(element, labels.filter);
    });

    root.querySelectorAll("option").forEach((element) => {
      const text = element.textContent.trim().toLowerCase();
      if (text === "most recent") {
        setTextIfChanged(element, labels.mostRecent);
      }
    });

    root.querySelectorAll(".jdgm-sort-dropdown, .jm-sort-filter__select").forEach((element) => {
      if (element.tagName === "SELECT") {
        const selected = element.options[element.selectedIndex];
        if (selected && selected.textContent.trim().toLowerCase() === "most recent") {
          setTextIfChanged(selected, labels.mostRecent);
        }
      }
    });
  }

  function reorderTabs(root) {
    const tabList = root.querySelector(".jdgm-tablist__list");
    const storeTab = root.querySelector("#jdgm-tab_shop_reviews");
    const productTab = root.querySelector("#jdgm-tab_product_reviews");

    if (tabList && storeTab && productTab && tabList.firstElementChild !== storeTab) {
      tabList.insertBefore(storeTab, productTab);
    }

    const tabContent = root.querySelector(".jdgm-tablist__content");
    const storePanel = root.querySelector("#jdgm-tabpanel_shop_reviews");
    const productPanel = root.querySelector("#jdgm-tabpanel_product_reviews");

    if (tabContent && storePanel && productPanel && tabContent.firstElementChild !== storePanel) {
      tabContent.insertBefore(storePanel, productPanel);
    }
  }

  function ensureStoreReviewsDefault(root) {
    const widgetRoot = root.querySelector("#judgeme_product_reviews");
    if (!widgetRoot || widgetRoot.dataset.amuminDefaultTabApplied === "true") {
      return;
    }

    const storeTab = root.querySelector("#jdgm-tab_shop_reviews");
    if (!storeTab) {
      return;
    }

    if (storeTab.getAttribute("aria-selected") === "true") {
      widgetRoot.dataset.amuminDefaultTabApplied = "true";
      widgetRoot.dataset.amuminDefaultTabApplying = "false";
    } else {
      if (widgetRoot.dataset.amuminDefaultTabApplying === "true") {
        return;
      }

      widgetRoot.dataset.amuminDefaultTabApplying = "true";
      requestAnimationFrame(() => {
        storeTab.click();
        window.setTimeout(() => {
          widgetRoot.dataset.amuminDefaultTabApplying = "false";
          scheduleEnhance(document);
        }, 120);
      });
    }
  }

  function resetStaleEnhancementFlags(review) {
    if (!review.querySelector(".amumin-review-meta")) {
      delete review.dataset.amuminMetaReady;
    }

    if (!review.querySelector(".amumin-review-actions")) {
      delete review.dataset.amuminTranslateReady;
    }

    if (!review.querySelector(".amumin-review-read-more")) {
      review.classList.remove("amumin-review-has-overflow");
    }
  }

  function normalizeDate(review) {
    const timestamp = getTimestampElement(review);
    if (!timestamp || timestamp.dataset.amuminDateReady === "true") {
      return;
    }

    const raw = timestamp.textContent.trim();
    if (/^\d{2}[/-]\d{2}[/-]\d{4}$/.test(raw)) {
      timestamp.textContent = raw.replace(/[/.]/g, "-");
      timestamp.classList.add("amumin-review-date");
    }

    timestamp.dataset.amuminDateReady = "true";
  }

  function moveStarsIntoMeta(review) {
    if (review.dataset.amuminMetaReady === "true") {
      return;
    }

    const author = getAuthorElement(review);
    const timestamp = getTimestampElement(review);
    const stars = getStarsElement(review);

    if (!author || !timestamp || !stars) {
      return;
    }

    const meta = document.createElement("div");
    meta.className = "amumin-review-meta";

    const authorInline = document.createElement("div");
    authorInline.className = "amumin-review-author";
    authorInline.textContent = author.textContent.trim();

    const reviewerInfo = author.closest(".jm-reviewer-info");
    const insertionTarget = reviewerInfo || author;

    if (reviewerInfo) {
      reviewerInfo.insertAdjacentElement("afterend", meta);
      reviewerInfo.style.display = "none";
    } else {
      insertionTarget.insertAdjacentElement("afterend", meta);
      if (author !== authorInline) {
        author.style.display = "none";
      }
    }

    meta.append(authorInline, timestamp, stars);
    review.dataset.amuminMetaReady = "true";
  }

  function createTranslationUI(review) {
    if (review.dataset.amuminTranslateReady === "true") {
      return;
    }

    const bodyElement = getReviewBodyElement(review);
    if (!bodyElement) {
      return;
    }

    review.dataset.amuminTranslateReady = "true";

    const actions = document.createElement("div");
    actions.className = "amumin-review-actions";

    const button = document.createElement("button");
    button.type = "button";
    button.className = "amumin-review-translate";
    button.textContent = labels.translate;
    actions.appendChild(button);
    bodyElement.insertAdjacentElement("afterend", actions);

    button.addEventListener("click", async function () {
      await toggleReviewTranslation(review, button);

      const modal = document.querySelector(".amumin-review-modal");
      if (modal && modal.__amuminCurrentReview === review && !modal.hidden) {
        populateReviewModal(modal, review);
      }
    });
  }

  function createReadMoreUI(review) {
    const titleElement = getReviewTitleElement(review);
    const bodyElement = getReviewBodyElement(review);

    if (!bodyElement) {
      return;
    }

    const existingButton = review.querySelector(".amumin-review-read-more");
    const shouldShow = hasOverflow(titleElement) || hasOverflow(bodyElement);

    if (!shouldShow) {
      existingButton?.remove();
      review.classList.remove("amumin-review-has-overflow");
      return;
    }

    review.classList.add("amumin-review-has-overflow");

    if (existingButton) {
      existingButton.textContent = labels.readMore;
      return;
    }

    const button = document.createElement("button");
    button.type = "button";
    button.className = "amumin-review-read-more";
    button.textContent = labels.readMore;
    button.addEventListener("click", () => openReviewModal(review));

    review.appendChild(button);
  }

  function enhance(root) {
    localizeWidgetCopy(root);
    reorderTabs(root);
    ensureStoreReviewsDefault(root);

    getReviewItems(root).forEach((review) => {
      resetStaleEnhancementFlags(review);
      normalizeDate(review);
      moveStarsIntoMeta(review);
      createTranslationUI(review);
      createReadMoreUI(review);
    });

    void ensureSixthDesktopReview(root);
  }

  function scheduleEnhance(root) {
    if (enhanceScheduled) {
      return;
    }

    enhanceScheduled = true;
    window.requestAnimationFrame(() => {
      enhanceScheduled = false;
      enhance(root);
    });
  }

  function queueEnhance(root, delay = 140) {
    if (pendingEnhanceTimeout) {
      window.clearTimeout(pendingEnhanceTimeout);
    }

    pendingEnhanceTimeout = window.setTimeout(() => {
      pendingEnhanceTimeout = null;
      scheduleEnhance(root);
    }, delay);
  }

  function schedulePostInteractionEnhance(root) {
    queueEnhance(root, 120);
    window.setTimeout(() => scheduleEnhance(root), 420);
  }

  function boot() {
    enhance(document);
    queueEnhance(document, 180);
    window.setTimeout(() => scheduleEnhance(document), 620);

    document.addEventListener("click", (event) => {
      const target = event.target;

      if (
        target instanceof HTMLElement &&
        target.closest(
          "#judgeme_product_reviews .jdgm-tab, " +
          "#judgeme_product_reviews .jm-pagination-controls__button, " +
          "#judgeme_product_reviews .jdgm-paginate__page, " +
          "#judgeme_product_reviews .jdgm-paginate__next-page, " +
          "#judgeme_product_reviews .jdgm-paginate__prev-page, " +
          "#judgeme_product_reviews .jm-custom-answer-filter"
        )
      ) {
        schedulePostInteractionEnhance(document);
      }
    });

    document.addEventListener("change", (event) => {
      const target = event.target;

      if (
        target instanceof HTMLElement &&
        target.closest(
          "#judgeme_product_reviews .jm-sort-filter__select, " +
          "#judgeme_product_reviews .jdgm-sort-dropdown"
        )
      ) {
        schedulePostInteractionEnhance(document);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
